import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './ui/SectionHeading';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-background py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-112" data-mp="1iwcxjc03p0fu">
      <div className="mx-auto max-w-6xl px-4" data-id="element-113" data-mp="1dxji3e196zd1">
        <SectionHeading id="modules-title" data-id="element-114" data-mp="1dunhtj1xnylf">The {totalVolumes} <span className="text-primary" data-id="element-115" data-mp="2bj7ew01mfjp3">Complete Volumes</span></SectionHeading>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-116" data-mp="26kmfg2u7141p">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.15
          }} transition={{
            duration: 0.3,
            delay: index % 3 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col rounded-xl border border-border bg-background p-6 shadow-sm" data-id="element-117" data-mp="21o5lut485xh8" data-mpi={index}>
                <div className="flex items-center gap-3" data-id="element-118" data-mp="1nttip94fj6hb">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary" data-id="element-119" data-mp="18xklse80h582">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-120" data-mp="1duuhucpwof4v" />
                  </span>
                  <p className="text-sm font-semibold text-accent" data-id="element-121" data-mp="103pp7ukygn41">Volume {module.number}</p>
                </div>
                <h3 className="mt-4 text-lg font-semibold leading-snug text-foreground" data-id="element-122" data-mp="14x0nv8fm5xkv">{module.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-123" data-mp="q84ffa9naijq">{module.summary}</p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}